import {CognitoUser} from 'amazon-cognito-identity-js'

import {CognitoGroups} from '@/utils/constants'

export function hasAccess(dealerId: string | undefined | null, cognitoUser: CognitoUser | null): boolean {
  if (!cognitoUser) return false

  const accessTokenPayload = cognitoUser?.getSignInUserSession()?.getAccessToken().decodePayload()
  const groups = accessTokenPayload?.['cognito:groups'] || []

  if (!groups.length) return false

  const rolesWithPermissions = [
    CognitoGroups.Admin,
    CognitoGroups.DealerAdmin,
    CognitoGroups.GarageManager,
    CognitoGroups.Imports,
    CognitoGroups.SalesAgent,
    CognitoGroups.StockAdmin,
  ]

  const hasRole = rolesWithPermissions.some(role => groups.includes(role))
  if (!hasRole) return false

  // If user has a valid role, allow access
  // The router guard will handle redirect to NoDealerId page if needed
  return true
}
